import React from 'react';

const svgProps = (size, className) => ({
  className,
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  overflow: 'visible',
  'aria-hidden': true,
});

export const IconCheck = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

export const IconX = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export const IconAlertTriangle = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);

/** 円形インフォ（r=9 で viewBox 内 stroke クリップを回避） */
export const IconInfo = ({ size = 22, className }) => (
  <svg {...svgProps(size, className)}>
    <circle cx="12" cy="12" r="9" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

/** 円形エラー（×） */
export const IconAlertCircle = ({ size = 18, className }) => (
  <svg {...svgProps(size, className)}>
    <circle cx="12" cy="12" r="9" />
    <line x1="15" y1="9" x2="9" y2="15" />
    <line x1="9" y1="9" x2="15" y2="15" />
  </svg>
);

export const IconCheckCircle = ({ size = 20, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const IconFlask = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M9 3h6v7.5l5.5 9.5a1 1 0 0 1-.87 1.5H4.37a1 1 0 0 1-.87-1.5L9 10.5V3z" />
    <line x1="9" y1="3" x2="15" y2="3" />
  </svg>
);

export const IconFileText = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
  </svg>
);

export const IconRefresh = ({ size = 14, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="23 4 23 10 17 10" />
    <polyline points="1 20 1 14 7 14" />
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
  </svg>
);

export const IconClipboard = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
    <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
  </svg>
);

export const IconChevronRight = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const IconChevronLeft = ({ size = 16, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const IconChevronUp = ({ size = 14, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="18 15 12 9 6 15" />
  </svg>
);

export const IconChevronDown = ({ size = 14, className }) => (
  <svg {...svgProps(size, className)}>
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
